// Local type definitions to replace @medusajs/admin-shared

export type CustomFieldModel = 
  | "product"
  | "product_variant"
  | "product_collection"
  | "customer"
  | "customer_group"
  | "order"
  | "region"
  | "store"
  | "user"

export type InjectionZone = 
  | "product.details.before"
  | "product.details.after"
  | "product.list.before"
  | "product.list.after"
  | "order.details.before"
  | "order.details.after"
  | "customer.details.before"
  | "customer.details.after"

export type NestedRoutePosition = "before" | "after"

export type CustomFieldContainerZone = 
  | "general"
  | "custom"

export type CustomFieldFormTab = 
  | "general"
  | "custom"

export type CustomFieldFormZone = 
  | "general"
  | "custom"

export const NESTED_ROUTE_POSITIONS: NestedRoutePosition[] = ["before", "after"]